import { FC } from 'react';
import Avatar from 'react-avatar';
import { StyledAvatar } from './Avatar.styles';
import { AllieAvatarProps } from './Avatar.types';
import { AllieImg } from '../Img';

export const AllieAvatar: FC<AllieAvatarProps> = ({
  children,
  src,
  name,
  height = 50,
  width = 50,
  imgProps,
  textSizeRatio = 3,
  color = 'primary-10',
  fgColor = 'primary-60',
  ...props
}) => {
  return src ? (
    <StyledAvatar height={height} width={width} {...props}>
      <AllieImg src={src} {...imgProps} />
    </StyledAvatar>
  ) : (
    <div {...props}>
      <Avatar
        color={`var(--allie-color-${color})`}
        fgColor={`var(--allie-color-${fgColor})`}
        name={name}
        maxInitials={2}
        size={String(height)}
        textSizeRatio={textSizeRatio}
        round
      />
    </div>
  );
};
